<script lang="ts">
	const range = Array.from({ length: 10 }, (_, i) => i);

	export let value = '0';
	export let priceColor = 'text-fx-gradient-23';
	export let fontSize = 24;

	$: transformStyle = `translateY(-${value * fontSize}px)`;
	$: ulStyle = `--font-size: ${fontSize}px`;
</script>

{#if !Array.from({ length: 10 }, (_, i) => i.toString()).includes(value)}
	{value}
{:else}
	<ul style={ulStyle}>
		{#each range as digit}
			<li style:transform={transformStyle} class={priceColor}>{digit}</li>
		{/each}
	</ul>
{/if}

<style>
	ul {
		display: flex;
		flex-direction: column;
		align-items: center;
		font-size: var(--font-size, 1rem);
		height: var(--font-size, 1rem);
		overflow: var(--overflow, hidden);

		list-style: none;
	}

	li {
		transition: 0.2s ease;
		height: var(--font-size, 1rem);
	}
</style>
